/// <reference path="../app.ts" />
namespace Cfnc {
    export class TranscriptOnly {
        static filterId: string = "transcriptOnly";

        static filter() {
            return function (items: Array<any>, apply: boolean) {
                if (apply) {
                    var result: Array<any> = [];

                    result = _.filter(items, (x) => {
                        var startedApp;
                        if (x.transcriptStatus && x.transcriptStatus.length > 0) {
                            startedApp = x.transcriptStatus[0].userStartedApp;
                        }

                        return x.hasApplication == false || startedApp == false;
                    });
                    return result;
                }
                else {
                    return items;
                }
            }
        }
    }
    angular.module("app").filter(TranscriptOnly.filterId, [TranscriptOnly.filter]);
}